import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { ChartTooltip } from './ChartTooltip';
import { CHART_GRADIENTS } from './chart-tokens';

/**
 * BarChart polido — gradient nas barras, rounded, animação stagger,
 * tooltip custom, axis discreto.
 */
export function RevenueExpensesChart({
  data,
  margin,
  xAxisInterval,
  minTickGap,
  tickFontSize,
  yAxisWidth,
  tickFormatter,
  formatCurrency,
  incomeLegend,
  expensesLegend,
}) {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data} margin={margin} barCategoryGap="20%">
        <defs>
          <linearGradient id={CHART_GRADIENTS.income.id} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={CHART_GRADIENTS.income.from} />
            <stop offset="100%" stopColor={CHART_GRADIENTS.income.to} />
          </linearGradient>
          <linearGradient id={CHART_GRADIENTS.expense.id} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={CHART_GRADIENTS.expense.from} />
            <stop offset="100%" stopColor={CHART_GRADIENTS.expense.to} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
        <XAxis
          dataKey="mes"
          stroke="#94a3b8"
          axisLine={false}
          tickLine={false}
          interval={xAxisInterval}
          minTickGap={minTickGap}
          tick={{ fontSize: tickFontSize, fill: '#64748b' }}
          tickMargin={10}
        />
        <YAxis
          stroke="#94a3b8"
          axisLine={false}
          tickLine={false}
          width={yAxisWidth}
          tick={{ fontSize: tickFontSize, fill: '#64748b' }}
          tickFormatter={tickFormatter}
        />
        <Tooltip
          content={<ChartTooltip formatter={(v) => formatCurrency(v)} />}
          cursor={{ fill: 'rgba(99, 102, 241, 0.06)' }}
        />
        <Legend
          iconType="circle"
          wrapperStyle={{ fontSize: `${tickFontSize}px`, paddingTop: 12 }}
        />
        <Bar
          dataKey="receita"
          name={incomeLegend}
          fill={`url(#${CHART_GRADIENTS.income.id})`}
          radius={[10, 10, 0, 0]}
          isAnimationActive
          animationDuration={1100}
          animationEasing="ease-out"
          maxBarSize={42}
        />
        <Bar
          dataKey="despesas"
          name={expensesLegend}
          fill={`url(#${CHART_GRADIENTS.expense.id})`}
          radius={[10, 10, 0, 0]}
          isAnimationActive
          animationDuration={1100}
          animationBegin={200}
          animationEasing="ease-out"
          maxBarSize={42}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}

export default RevenueExpensesChart;
